import { withRouter } from "react-router-dom";

import React, { useEffect, useRef, useState } from 'react';

import {
  Grid,
  Avatar,
  Typography,
  LinearProgress,
  Box,
  Drawer,
  Badge,
  Button
} from '@mui/material';

import useResponsive from '../../utils/useResponsive';

import Products from "../../components/Products";
import ProductFilters from "../../components/ProductFilters";
import { useSelector, useDispatch } from 'react-redux';

import { FiSearch, FiFilter } from 'react-icons/fi';

import Actions from "../../constants/Actions";
import useDebounce from "../../utils/useDebounce";
import { countActiveFilters } from "../../utils/filterOptions";
import buscarProdutosComFiltros from "../../actions/v2/produtos/buscarProdutosComFiltros";
import listaCodigoFiliais from "../../actions/cadastro/lista-codigo-filiais";

function OrderPage() {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.loading);
  const loadingPage = useSelector(state => state.loadingPage);
  const loadingProducts = useSelector(state => state.loadingProducts);
  const search = useSelector(state => state.search);
  const filters = useSelector(state => state.filters);
  const filialOptions = useSelector(state => state.filialOptions);
  const productsPagination = useSelector(state => state.productsPagination);

  const isDesktop = useResponsive('up', 'md');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const debouncedFilters = useDebounce(filters, 400);
  const didMountRef = useRef(false);

  const activeFilters = countActiveFilters(filters);
  const hasMore = productsPagination?.hasMore || false;
  const currentPage = productsPagination?.page || 1;
  const pageSize = productsPagination?.pageSize || 60;
  const total = productsPagination?.total || 0;

  const handleLoadMore = () => {
    buscarProdutosComFiltros(dispatch, {
      search,
      filters: debouncedFilters,
      page: currentPage + 1,
      pageSize,
      silent: true
    });
  };

  // Carrega opções de filial uma única vez
  useEffect(() => {
    if (!filialOptions || filialOptions.length === 0) {
      listaCodigoFiliais()
        .then(res => {
          dispatch({
            type: Actions.SET_FILIAL_OPTIONS,
            filialOptions: res.data || []
          });
        })
        .catch(err => console.error('Erro ao carregar filiais:', err));
    }
  }, []);

  // Re-busca quando filtros (debounced) mudam — pulando o primeiro mount
  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    buscarProdutosComFiltros(dispatch, {
      search,
      filters: debouncedFilters,
      page: 1,
      silent: true
    });
  }, [debouncedFilters]);

  const showLoading = loading === true || loadingPage === true || loadingProducts === true;

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {showLoading && <LinearProgress />}

      {/* Content */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        <Grid container spacing={2}>
          {isDesktop && (
            <Grid item md={3} lg={2}>
              <Box sx={{ position: 'sticky', top: 80 }}>
                <ProductFilters />
              </Box>
            </Grid>
          )}
          <Grid item xs={12} md={9} lg={10}>
            <Products />
            {hasMore && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Button
                  variant="contained"
                  onClick={handleLoadMore}
                  disabled={loadingProducts}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 700,
                    bgcolor: '#1a1a2e',
                    '&:hover': { bgcolor: '#2a2a3e' }
                  }}
                >
                  {loadingProducts ? 'Carregando...' : `Carregar mais (${Math.max(total - currentPage * pageSize, 0)} restantes)`}
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>

      {/* Drawer mobile */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: { xs: '85vw', sm: 320 } } }}
      >
        <ProductFilters onClose={() => setDrawerOpen(false)} />
      </Drawer>
    </Box>
  );
}

export default withRouter(OrderPage);
